import React from 'react';
import styled from 'styled-components';
import Select from 'react-select';
import {
  REGION_OPTIONS,
  AGE_GROUP_OPTIONS,
  DOSE_OPTIONS,
  VACCINE_OPTIONS,
} from '../../app/config';

const StyledFilters = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 576px) {
    flex-direction: column;
  }
`;
const FormGroup = styled.div`
  &:not(:last-child) {
    margin-right: 1em;
  }
  flex: ${({ flex }) => flex};
  @media (max-width: 576px) {
    &:not(:last-child) {
      margin-right: 0;
      margin-bottom: 0.5em;
    }
  }
`;
const FormLabel = styled.label`
  margin-bottom: 4px;
`;
const noOptions = 'Žiadne ďalšie možnosti nie sú k dispozícii';

function Filters({
  selectedDatasets,
  setSelectedDatasets,
  datasets,
  filters,
  setFilters,
  selectedDose,
  setSelectedDose,
  selectedVaccine,
  setSelectedVaccine,
}) {
  return (
    <StyledFilters>
      <FormGroup flex={0.7}>
        <FormLabel htmlFor="dataset-selector">Dátum</FormLabel>
        <Select
          inputId="dataset-selector"
          value={selectedDatasets}
          onChange={setSelectedDatasets}
          isMulti
          options={datasets}
          placeholder={'Vyberte dátum(y)'}
          noOptionsMessage={() => noOptions}
          isClearable={false}
          isSearchable={false}
        />
      </FormGroup>
      <FormGroup flex={0.5}>
        <FormLabel htmlFor="dose-selector">Dávka</FormLabel>
        <Select
          inputId="dose-selector"
          value={selectedDose}
          onChange={setSelectedDose}
          isMulti
          options={DOSE_OPTIONS}
          placeholder={'Vyberte dávku'}
          noOptionsMessage={() => noOptions}
          isClearable={false}
          isSearchable={false}
        />
      </FormGroup>
      <FormGroup flex={0.9}>
        <FormLabel htmlFor="vaccine-selector">Vakcína</FormLabel>
        <Select
          inputId="vaccine-selector"
          value={selectedVaccine}
          onChange={setSelectedVaccine}
          isMulti
          options={VACCINE_OPTIONS}
          placeholder={'Vyberte typ vakcíny'}
          noOptionsMessage={() => noOptions}
          isClearable={false}
          isSearchable={false}
        />
      </FormGroup>
      <FormGroup flex={1.4}>
        <FormLabel htmlFor="region-selector">Kraj</FormLabel>
        <Select
          inputId="region-selector"
          value={filters.regions}
          onChange={(value) => setFilters({ ...filters, regions: value })}
          isMulti
          options={REGION_OPTIONS}
          placeholder={'Vyberte kraj'}
          noOptionsMessage={() => noOptions}
          isSearchable={false}
        />
      </FormGroup>
      <FormGroup flex={1.4}>
        <FormLabel htmlFor="age-selector">Veková skupina</FormLabel>
        <Select
          inputId="age-selector"
          value={filters.ageGroups}
          onChange={(value) => setFilters({ ...filters, ageGroups: value })}
          isMulti
          options={AGE_GROUP_OPTIONS}
          placeholder={'Vyberte vekovú skupinu'}
          noOptionsMessage={() => noOptions}
          isSearchable={false}
        />
      </FormGroup>
    </StyledFilters>
  );
}

export default Filters;
